import React, { useMemo } from 'react';
import { ClaimActivityReportIcon } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core';

import { useFavoriteReportHandler } from '../../hooks';
import { ReportTypeKeys } from '../../report.types';
import { useClaimsActivityReportBriefQuery } from '../../ReportDetails/ClaimsActivityReport/queries';
import ReportCardBase, { ReportCardBaseProps } from '../ReportCardBase';

interface Props extends ReportCardBaseProps {}
const TEST_ID = 'claims-activity-report-card';
const ClaimsActivityReportCard: React.FC<Props> = ({ isFavoriteMode }) => {
  const {
    data: { paidCount, submittedCount },
    title,
    isEmpty,
    isLoading,
  } = useClaimsActivityReportBriefQuery();
  const {
    observingOrganization: { type },
  } = useCurrentOrganization();

  const isSystem = useMemo(() => type === OrganizationTypes.system, [type]);
  const childrenNode = useMemo(() => {
    if (!isSystem && !isEmpty) {
      return (
        <ReportCardBase.DescriptionBase
          isLoading={isLoading}
          title={title}
          testId={TEST_ID}
          items={[
            {
              label: 'Paid',
              value: `${paidCount || 0}`,
            },
            {
              label: 'Submitted',
              value: `${submittedCount || 0}`,
            },
          ]}
        />
      );
    }
    return null;
  }, [isEmpty, isLoading, isSystem, paidCount, submittedCount, title]);
  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.ClaimsActivity);

  return (
    <ReportCardBase
      // isUpdated
      isWideMode={isFavoriteMode}
      url={ROUTES.CLAIMS_ACTIVITY_REPORT}
      isFavorite={isFavorite}
      testId={TEST_ID}
      onChangeFavorite={handleToggleReportKey}
      icon={
        <ClaimActivityReportIcon
          size={isFavoriteMode ? '50px' : '40px'}
          color={isFavoriteMode ? 'iconAccent' : 'iconDisabled'}
        />
      }
      title="Claim Activity"
      description="Track participant claims, including
submissions, statuses, payments, and
plan year data"
    >
      {childrenNode}
    </ReportCardBase>
  );
};
export default ClaimsActivityReportCard;
